module.exports = __webpack_public_path__ + "KG.png?6f69b51daf5a831e5a2f8e2cca94a02d";